import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';

/* Actions */
import {
	createNewBinder,
	saveBrochuresDetails,
	dropProductSpecsEmail,
	sendEmailSuccessDialog
} from '../../../redux/actions';

class BinderStep2 extends Component {

	doServiceCallForBinder(type, operation, event) {
		event && event.preventDefault();
		var self = this;
		let { state } = this.props,
			payload = state.brochure.payload;

		//Set username and account number in payload
		payload.brochure.userId = state.user.userDetails && state.user.userDetails.sso;

		//delete file url from payload
		delete payload.brochure.fileURL;

		let binders = state.brochure.payload.binders[state.brochure.payload.binders.length-1];

		var totalNoOfPages = (binders.hasCoverPage === "Y"?1:0)+(binders.hasDividerPages === "Y"?payload.brochure.pages.length:0)+(binders.hasSpecPages === "Y"?payload.brochure.pages.length:0)+(binders.hasWarrantyInfoPages === "Y"?13:0)+(binders.hasMortgageCalcSheet === "Y"?1:0);

		payload.binders[state.brochure.payload.binders.length-1].totalPages = totalNoOfPages;
		payload.binders[state.brochure.payload.binders.length-1].status = (type === "save"?"Save":"Submitted");

		//remove dividerPageNames
		delete payload.binders[state.brochure.payload.binders.length-1].dividerPageName;

		//Update payload for rqeuired currency format
		payload.brochure.pages.map((item, index) => {
			if(item.price !== "") {
				item.price = self.props.formatMoney(item.price, 0, ".", ",", false)
			} else {
				item.products.map((itm, ind) => {
					itm.price = self.props.formatMoney(itm.price, 0, ".", ",", false)
					return null;
				})
			}
			return null;
		});

		if(type !== "new") {
			//remove binder from payload
			payload = JSON.parse(JSON.stringify(payload));
			delete payload.binders;
			payload = payload.brochure;
		}

		//Service call for create binder
		self.props.createNewBinder(payload, type === "new"?"requestType=createBinder":"", type === "new", (response) => {
			if(response.status) {
				//Do service call of email service{
				if(type === "new") {
					self.props.dropProductSpecsEmail({
						toEmail: payload.binders[state.brochure.payload.binders.length-1].emailAddress,
		                emailSubject: 'GE Appliances Product Binder',
		                emailMessage: '',
		                specURL: '<a href="' + response.responseObject + '">Click here to download the binder</a>'
					}, "emailType=Spec", response => {
						self.props.sendEmailSuccessDialog(true);
						browserHistory.push("/binder/"+type+"/confirmation");
					});
				} else {
					browserHistory.push("/binder/"+type+"/confirmation");
				}
			} else {
				browserHistory.push("/error");
			}
		});
	}

	componentWillMount() {
		window.scrollTo(0, 0);
		if(this.props.state.brochure.selectedItems.length === 0 && this.props.state.brochure && this.props.state.brochure.payload) {
			//Redirect to list page if user directly comes on this page
			browserHistory.push("/list");
		}
	}

	render() {
		let { state } = this.props;
		let { brochure } = state.brochure.payload;
		let binders = state.brochure.payload.binders.length > 0?state.brochure.payload.binders[state.brochure.payload.binders.length-1]:{};

		var emailAddress = binders && binders.emailAddress && binders.emailAddress !== ""?binders.emailAddress.split(","):[],
			emailAddressMarkup = [];
		for(var i=0;i<emailAddress.length;i++) {
			emailAddressMarkup.push(<span key={i+1}>{emailAddress[i].trim()}<br/></span>);
		}
		var totalNoOfPages = (binders && binders.hasCoverPage === "Y"?1:0)+(binders && binders.hasDividerPages === "Y"?brochure.pages.length:0)+(binders && binders.hasSpecPages === "Y"?brochure.pages.length:0)+(binders && binders.hasWarrantyInfoPages === "Y"?13:0)+(binders && binders.hasMortgageCalcSheet === "Y"?1:0);
    	return (
		  	<div>
		        <div className="push"><h1>Order Binder</h1></div>
		        	<div className="push">
		          	<h2 className="pageTitle">Review &amp; Submit Binder Order</h2>
		          	<p className="bold">Please review the following information before submitting your binder order.</p>
		        </div>
		        <div className="push">
		        	<div className="columns">
		        		<div className="column column1">
		            		<h3>Pages Included in Each Binder:</h3>
		            		<div className="shadedBox binderReviewShadedBox">
		                		<table className="binderReviewTable binderReviewTableA">
				                	<thead>
					                    <tr>
					                    	<th>Page Type:</th>
					                        <th className="txt-ctr"># Pages</th>
					                    </tr>
			                		</thead>
			                		<tbody>
										{binders.hasCoverPage === "Y"
											?<tr>
						                    	<td>Cover Page</td>
						                     	<td className="txt-ctr">1</td>
						                    </tr>
											:null
										}
										{binders.hasDividerPages === "Y"
											?<tr>
						                    	<td>Divider Pages</td>
						                      	<td className="txt-ctr">{brochure.pages.length}</td>
						                    </tr>
											:null
										}
										{binders.hasSpecPages === "Y"
											?<tr>
						                     	<td>Spec Pages ({binders.specPageSets} set)</td>
						                        <td className="txt-ctr">{brochure.pages.length}</td>
						                    </tr>
											:null
										}
										{binders.hasWarrantyInfoPages === "Y"
											?<tr>
						                    	<td>Warranty Information Pages</td>
						                      	<td className="txt-ctr">13</td>
						                    </tr>
											:null
										}
										{binders.hasMortgageCalcSheet === "Y"
											?<tr>
						                      	<td>Mortage Calculation Spreadsheet</td>
						                      	<td className="txt-ctr">1</td>
						                    </tr>
											:null
										}
		                  			</tbody>
				                  	<tfoot>
					                    <tr>
					                    	<td>Total number of pages</td>
					                      	<td className="txt-ctr">{totalNoOfPages}</td>
		                    			</tr>
		                  			</tfoot>
		                		</table>
		              		</div>
		            	</div>
		          	</div>
		          	<p>
				  		<Link className="withIcon withEditIcon noUnderline uppercase bold" to="/create-binder-step1">Edit Binder</Link>
		          	</p>
		        </div>
				<div className="push">
		          	<h3>Distribution of the Binder</h3>
		          	<div className="indented">
						<p className="indentButNotFirstLine">
			              	<strong>Emails will be sent to the following addresses to download the binder:</strong><br />
							{emailAddressMarkup}
			            </p>
		          	</div>
		        </div>
		        <p className="textRight">
		          	<a className="blueButton" href="" onClick={this.doServiceCallForBinder.bind(this, "save", (brochure.brochureId?"PUT":"POST"))}>Save as Brochure</a>
		          	&nbsp;&nbsp;
				  	<a className="blueButton" href="" onClick={this.doServiceCallForBinder.bind(this, "new", (brochure.brochureId?"PUT":"POST"))}>Create Binder</a>
		        </p>
		  	</div>
		);
  	}
};
const mapStateToProps = (state) => {
	return { state };
};
const mapDispatchToProps = (dispatch) => ({
	createNewBinder: (payload, hybridQueryParams, useBootAPI, callback) => dispatch(createNewBinder(payload, hybridQueryParams, useBootAPI, callback)),
	saveBrochuresDetails: (payload) => dispatch(saveBrochuresDetails(payload)),
	dropProductSpecsEmail: (payload, hybridQueryParams, callback) => dispatch(dropProductSpecsEmail(payload, hybridQueryParams, callback)),
    sendEmailSuccessDialog: (emailSendSuccessDialog) => dispatch(sendEmailSuccessDialog(emailSendSuccessDialog))
});

BinderStep2 = connect(mapStateToProps, mapDispatchToProps)(BinderStep2);
export default BinderStep2;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Binders/step2.js